import type { ComponentType, SVGProps } from 'react';
import { CalendarDaysIcon, HomeIcon, UserIcon } from '@heroicons/react/24/outline';
import { $path } from 'safe-routes';

export type PaymentsFloatingNavItemId = 'home' | 'reservations' | 'profile';

type NavIcon = ComponentType<SVGProps<SVGSVGElement>>;

export type PaymentsFloatingNavItem = {
  id: PaymentsFloatingNavItemId;
  label: string;
  Icon: NavIcon;
  to: string;
  end?: boolean;
};

export const paymentsFloatingNavItems: PaymentsFloatingNavItem[] = [
  { id: 'home', label: 'Home', Icon: HomeIcon, to: $path('/'), end: true },
  {
    id: 'reservations',
    label: 'Reservations',
    Icon: CalendarDaysIcon,
    to: $path('/reservations'),
  },
  { id: 'profile', label: 'Profile', Icon: UserIcon, to: $path('/profile') },
];
